var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "500px" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { attrs: { "min-width": "400px" } },
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [_vm._v("Changing Group")]),
          ]),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-1",
                  attrs: { icon: "", color: "red" },
                  on: { click: _vm.onClose },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-select", {
                staticStyle: { padding: "0 25px" },
                attrs: { items: _vm.existingGroups },
                model: {
                  value: _vm.newGroup,
                  callback: function ($$v) {
                    _vm.newGroup = $$v
                  },
                  expression: "newGroup",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: { loading: _vm.buttonLoading, color: "primary" },
                  on: { click: _vm.onPressUse },
                },
                [_vm._v("CHANGE ")]
              ),
              _c("v-spacer"),
            ],
            1
          ),
          _c("v-divider", { staticClass: "mx-4" }),
          _c("v-card-title", [
            _c("span", { staticClass: "subtitle-1" }, [_vm._v("Rename Group")]),
          ]),
          _c(
            "v-card-actions",
            [
              _c("v-text-field", {
                directives: [{ name: "ascii-only", rawName: "v-ascii-only" }],
                staticStyle: { padding: "0 25px" },
                attrs: { label: "New Group Name", outlined: "", dense: "" },
                model: {
                  value: _vm.renameGroupName,
                  callback: function ($$v) {
                    _vm.renameGroupName = $$v
                  },
                  expression: "renameGroupName",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: { loading: _vm.renameLoading, color: "primary" },
                  on: { click: _vm.onPressRename },
                },
                [_vm._v("RENAME ")]
              ),
              _c("v-spacer"),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }